<div id="anagrafica-aziendale" class="content p-4 my-3">
    <app-anagrafica-azienda [anagAzienda]="orgDetail" [anagUserAzienda]="userDetail" [showCoripetButtons]="true"></app-anagrafica-azienda>
</div>